import { render, staticRenderFns } from "./form-wrapper.vue?vue&type=template&id=f1ce481c"
import script from "./form-wrapper.vue?vue&type=script&lang=js"
export * from "./form-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1ce481c')) {
      api.createRecord('f1ce481c', component.options)
    } else {
      api.reload('f1ce481c', component.options)
    }
    module.hot.accept("./form-wrapper.vue?vue&type=template&id=f1ce481c", function () {
      api.rerender('f1ce481c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/shared/send-list-conversation/edit-item/form-wrapper.vue"
export default component.exports